import { ItemsList } from "../components";

const ItemsPage = () => {
  return (
    <div>
      <header>Items List</header>

      <ItemsList />
    </div>
  );
};

export default ItemsPage;
